module.exports = __webpack_public_path__ + "static/media/sched.061b27b8.svg";